import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  ViewChild
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import {
  BrowserQRCodeReader
} from '@zxing/browser';

import {
  MessstelleQrService
} from '../../../../../Services/messstelle-qr.service';


export interface MessstelleQrScannerDialogData {

  messstelleId: number;

  ersetzen: boolean;
}


@Component({
  selector:
    'app-messstelle-qr-scanner-dialog',

  templateUrl:
    './messstelle-qr-scanner-dialog.component.html',

  styleUrls: [
    './messstelle-qr-scanner-dialog.component.css'
  ]
})
export class MessstelleQrScannerDialogComponent
  implements AfterViewInit, OnDestroy {


  @ViewChild(
    'video',
    {
      static: true
    }
  )
  video!:
    ElementRef<HTMLVideoElement>;


  private readonly reader =
    new BrowserQRCodeReader();


  private controls:
    {
      stop: () => void;
    }
    | null =
    null;


  private verarbeitet =
    false;


  saving =
    false;


  fehler =
    '';


  constructor(

    private qrService:
      MessstelleQrService,

    private dialogRef:
      MatDialogRef<MessstelleQrScannerDialogComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data:
      MessstelleQrScannerDialogData

  ) { }


  ngAfterViewInit(): void {

    this.startScanner();
  }


  private async startScanner():
    Promise<void> {

    this.fehler = '';

    this.verarbeitet = false;


    try {

      this.controls =
        await this.reader
          .decodeFromVideoDevice(

            undefined,

            this.video.nativeElement,

            result => {

              if (
                !result
                ||
                this.verarbeitet
              ) {
                return;
              }


              this.verarbeitet =
                true;


              this.controls?.stop();


              this.uebernehmen(
                result.getText()
              );
            }
          );

    }
    catch (err) {

      console.error(
        'QR-Scanner konnte nicht gestartet werden:',
        err
      );


      this.fehler =
        'Die Kamera konnte nicht gestartet werden. Bitte prüfe die Kameraberechtigung.';
    }
  }


  private uebernehmen(
    wert: string
  ): void {

    if (this.saving) {
      return;
    }

    this.saving = true;
    this.fehler = '';

    const request =
      this.data.ersetzen
        ? this.qrService.ersetzen(
          this.data.messstelleId,
          wert
        )
        : this.qrService.zuordnen(
          this.data.messstelleId,
          wert
        );

    request.subscribe({

      next: qr => {

        this.saving = false;

        // Kamera sicher stoppen
        this.controls?.stop();

        // Dialog schließen und Ergebnis
        // an Messstellen-Seite zurückgeben
        this.dialogRef.close({
          qr,
          ersetzt: this.data.ersetzen
        });
      },

      error: err => {

        console.error(
          'QR-Code konnte nicht zugeordnet werden:',
          err
        );

        this.saving = false;

        this.fehler =
          err?.error?.message
          ??
          'Der QR-Code konnte nicht zugewiesen werden.';

        /*
         * WICHTIG:
         * Nicht automatisch neu starten.
         *
         * Sonst scannt die Kamera sofort wieder
         * denselben QR-Code und man hängt
         * in einer Fehlerschleife.
         */
      }

    });
  }

  erneutScannen(): void {

    if (this.saving) {
      return;
    }

    this.fehler = '';

    this.startScanner();
  }


  schliessen(): void {

    this.dialogRef.close();
  }


  ngOnDestroy(): void {

    this.controls?.stop();
  }


}